import axios from '@/api/config';

const discountCoupon = {
    getDiscountCouponTypeList(data) {
        return axios.get(`${process.env.BASE_URL}/discountCoupon/getDiscountCouponTypeList`, { params: data });
    },
    getDiscountCoupon(data) {
        return axios.get(`${process.env.BASE_URL}/discountCoupon/getDiscountCoupon`, { params: data });
    },
    pageList(data) {
        return axios.post(`${process.env.BASE_URL}/discountCoupon/pageList`, data);
    },

    // addDiscountCoupon(data) {
    //     return axios.put(`${process.env.BASE_URL}/discountCoupon/addDiscountCoupon`, data);
    // },
    addDiscountCoupon(data) {
        return axios.post(`${process.env.BASE_URL}/discountCoupon/addDiscountCoupon`, data);
    },
    updateDiscountCoupon(data) {
        return axios.post(`${process.env.BASE_URL}/discountCoupon/updateDiscountCoupon`, data);
    },
    updateVideoCourseState(data) {
        return axios.post(`${process.env.BASE_URL}/discountCoupon/updateVideoCourseState`, data);
    },
}

export default discountCoupon;



// WEBPACK FOOTER //
// ./src/api/discountCoupon.js